import { Link } from '@tanstack/react-router'
import Button from '@/components/Button'

interface ErrorFallbackProps {
  title?: string
  message?: string
  backTo?: string
  backLabel?: string
  variant?: 'inline' | 'fullpage' | 'card'
}

const ErrorFallback = ({
  title = 'Oops!',
  message = 'Something went wrong. Please try again.',
  backTo = '/books/search',
  backLabel = 'Back to Search',
  variant = 'card'
}: ErrorFallbackProps) => {
  const containerClasses = {
    inline: 'text-center py-8',
    fullpage: 'flex items-center justify-center min-h-[60vh] pt-24',
    card: 'flex-1 bg-neutral-100 rounded-[15px] p-7 flex flex-col items-center justify-center gap-y-7'
  }

  return (
    <div className={containerClasses[variant]}>
      <div className="text-center">
        <h3 className="text-[24px] font-bold text-error-500 mb-4">{title}</h3>
        <p className="text-neutral-600 mb-6">{message}</p>
        <Link to={backTo}>
          <Button size="sm" className="bg-action-500 hover:bg-action-600">
            {backLabel}
          </Button>
        </Link>
      </div>
    </div>
  )
}

export default ErrorFallback
